import type { Header, Row } from "./types";

export function isDataValid(headers: Header[], rows: Row[]) {
  return [headers, ...rows].every(({ length }) => length >= 2);
}

export function getSelectItems(rows: Row[]) {
  return rows.map((row, rowIndex) => ({
    id: `${rowIndex}`,
    title: row[0]!.text,
    value: row[0]!.text,
  }));
}
